module.exports = __webpack_public_path__ + "static/media/EBlogo.0f1af3cc.png";